// assets
import { DashboardOutlined } from '@ant-design/icons';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import dashboardIcon from "../../icons/sidebar/dashboard.svg"

// icons
const icons = {
  DashboardOutlined
};

const Dashboard = () => <img src={dashboardIcon} alt="icon" />;
// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: Dashboard,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
